import React, {useEffect} from "react";
import {Layout} from "@components/layout/Layout";
import {Link} from "react-router-dom";
import {PRIVACY_POLICY,COOKIE_POLICY,RISK_DISCLOSURE,TERMS_CONDITIONS} from "../../../constants";

export const AboutUs = () => {

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight / 3) {
        document.body.classList.add("show-scroll-btn");
      } else {
        document.body.classList.remove("show-scroll-btn");
      }
    };
    const handleClick = () => {
      document.body.classList.toggle("hidden");
      document.documentElement.classList.toggle("hidden");
    };

    // Bind events
    const checkMenu = document.getElementById("check-menu");
    if (checkMenu) {
      checkMenu.addEventListener("click", handleClick);
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      if (checkMenu) {
        checkMenu.removeEventListener("click", handleClick);
      }
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    document.body.classList.add('main-page');
    return () => {
      document.body.classList?.remove('main-page');
    };
  }, []);
const hostname = window.location.hostname; 
const parts = hostname.split('.');

let baseDomain = '';

if (parts.length === 2) {
  baseDomain = hostname; 
} else if (parts.length > 2) {
  baseDomain = parts.slice(-2).join('.'); 
}

const signupUrl = `https://app.${baseDomain}/auth/signup`; 
  return (<Layout>
    <div className="basic-main about-us-main">
      <figure className="about-us-header-img"><img src={require("@assets/images/main/about-us-header-img.jpg")}
                                                   alt="img"/></figure>
      <div className="container">
        <div className="about-us-header-section section">
          <h1>We aim to redefine the way people trade by making it smarter, simpler, and more accessible.</h1>
          <p className="h3">Cronika was created by a passionate team of IT and FinTech professionals who set out to rethink how people interact with financial markets.</p>
          <p className="h3">Today, that vision drives everything we do. We’re continuously refining and reinventing the trading process to create a seamless experience. Our core belief remains unchanged: everyone, regardless of their background or location, should have the opportunity to trade freely and confidently.</p>
        </div>
        <div className="advantages-section section">
          <h2>Why Cronika?</h2>
          <p className="h3">Our journey began as a modest startup with just a few early adopters. Back then, we were new to the market — our platform was still evolving, and our services were far from what they are today.</p>
          <p className="h3">Yet, by the close of 2017, we had already achieved:</p>

          <div className="advantages-box">
            <ul>
            <li><span className="value">{'>10 000'}</span> early access sign-ups</li>
            <li><span className="value">{'>$15M'}</span> test phase trading turnover</li>
              <li><span className="value">20+</span>targeted countries and regions</li>
              <li><span className="value">$600+</span>estimated average monthly trader income</li>
            </ul>
            <div className="advantages-banner">
              <figure className="advantages-banner-img"><img
                src={require("@assets/images/main/advantages-banner-img.png")} alt="img"/></figure>
              <div className="social-media">    
                          
              <a href="https://www.instagram.com/cronikaofficial?igsh=MW5odWk1bTYxd2s2cQ%3D%3D&amp;utm_source=qr" target="_blank">
                <img
              src={require("@assets/images/main/instagram-icon.svg").default} alt="icon"/>
              </a>
              <a href="https://t.me/CronikaMain" target="_blank" ><img
              src={require("@assets/images/main/telegram-icon.svg").default} alt="icon"/>
              </a>
              <a href="https://www.youtube.com/@cronikamain"  target="_blank">
                <img
              src={require("@assets/images/main/youtube-icon.svg").default} alt="icon"/>
              </a>
              <a href="https://www.tiktok.com/@cronikamain?_t=ZN-8vzdRUzWm8M&_r=1"  target="_blank">
                <img
              src={require("@assets/images/main/tiktok-icon-white.svg").default} alt="icon"/>
              </a>
              <a href="https://x.com/cronikaofficial?s=21" target="_blank" >
                <img
              src={require("@assets/images/main/x-icon-white.svg").default} alt="icon"/>
              </a>
              </div>
              <p>The number of active users who value our platform continues to grow rapidly. Thanks to our strong community and client-first approach, Cronika has reached key milestones and expanded its global presence — with more traders joining us every day.</p>
              {/* <Link
              className="basic-button" to={AUTH_SIGN_UP}>Join</Link> */}
                         <a className="basic-button" href={signupUrl}>Join</a>

            </div>
          </div>
        </div>
        <div className="reviews-box section">
          <div className="title-review">
            <div className="basic-logo"><img src={require("@assets/images/main/basic-logo.svg").default} alt="logo"/>
            </div>
            <h2>Our Approach to Client Collaboration</h2>
            <div className="review-author">
              <figure className="author-photo"><img src={require("@assets/images/main/head_of_client.jpg")} alt="photo"/>
              </figure>
              <span className="author-name">
              Elena K.  <br/>Head of Client Relations</span>
            </div>
          </div>
          <div className="review-item">
            <p>From day one, client satisfaction has been at the heart of everything we do. Our goal extends beyond delivering top-tier support — we actively listen, adapt, and grow based on the insights our users share. Some of our best features were born from real trader feedback. After all, Cronika is built <i> by traders, for traders</i></p>
          </div>
        </div>
        <div className="document-section section">
          <div className="document-title"><img src={require("@assets/images/main/documents-img.png")} alt="photo"/>
            <h2>Documents</h2>
          </div>
          <div className="document-links">
            <Link to={TERMS_CONDITIONS}>Terms and Conditions</Link>
            <Link to={PRIVACY_POLICY}>Privacy policy</Link>
            <Link to={RISK_DISCLOSURE}>Risk Disclosure</Link>
            <Link to={COOKIE_POLICY}>Cookie Policy</Link>
            {/* <Link to="#">AML and KYC policy</Link> */}
            </div>
        </div>
        <div className="section">
          <h2>What We Stand For  <br/>The Values Behind the Vision</h2>
          <div className="core-values-box">
            <div className="box">
              <figure className="core-value-icon"><img
                src={require("@assets/images/main/core-value-icon01.svg").default} alt="icon"/></figure>
              <h2>Innovation <mark>-Driven</mark></h2>
              <p>We’re constantly evolving — striving for excellence through breakthrough features and trend-setting solutions that keep us at the forefront of the trading industry.</p>
            </div>
            <div className="box">
              <figure className="core-value-icon"><img
                src={require("@assets/images/main/core-value-icon02.svg").default} alt="icon"/></figure>
              <h2>Client-Centered Loyalty</h2>
              <p>Our focus is on empowering traders to succeed and building lasting relationships. We do this by staying responsive, relevant, and consistently delivering premium service.</p>
            </div>
            <div className="box large-box"><img src={require("@assets/images/main/core-value-bg01.jpg")} alt="img"/>
              <figure className="core-value-icon"><img
                src={require("@assets/images/main/core-value-icon03.svg").default} alt="icon"/></figure>
              <h2>Genuinely Social</h2>
              <p>We’re community-first. The support, interaction, and connection between our users shape who we are. Creating a space that’s open, comfortable, and social is our top priority.</p>
            </div>
            <div className="box">
              <figure className="core-value-icon"><img
                src={require("@assets/images/main/core-value-icon04.svg").default} alt="icon"/></figure>
              <h2>Sustainable Growth</h2>
              <p>We invest in people. By attracting top talent, nurturing development, and fostering a culture of collaboration, we ensure long-term strength for both our team and our clients.</p>
            </div>
            <div className="box">
              <figure className="core-value-icon"><img
                src={require("@assets/images/main/core-value-icon05.svg").default} alt="icon"/></figure>
              <h2>Integrity Above All</h2>
              <p>Ethics, transparency, and legal compliance guide every decision. As a global company, we uphold the highest standards to earn and keep the trust of our users worldwide.</p>
            </div>
            <div className="box large-box"><img src={require("@assets/images/main/core-value-bg02.jpg")} alt="img"/>
              <figure className="core-value-icon"><img
                src={require("@assets/images/main/core-value-icon06.svg").default} alt="icon"/></figure>
              <h2>Global Success</h2>
              <p>Our goal is simple: to make trading accessible, intuitive, and rewarding for everyone — anywhere, anytime. When our users succeed, we succeed together.</p>
            </div>
          </div>
        </div>
        <div className="social-media-section section">
          <h2>In the Spotlight</h2>
          <p className="h3">See how our community, services, and innovations are shaping the industry and making waves around the world, every single day.</p>
          <div className="social-media">
            
            <a href="https://www.youtube.com/@cronikamain" target="_blank"><img
            src={require("@assets/images/main/youtube-icon-yellow.svg").default} alt="icon"/></a>
            <a href="https://www.instagram.com/cronikaofficial?igsh=MW5odWk1bTYxd2s2cQ%3D%3D&amp;utm_source=qr"
            target="_blank"><img src={require("@assets/images/main/instagram-icon-yellow.svg").default} alt="icon"/></a>
            <a href="https://t.me/CronikaMain" target="_blank"><img src={require("@assets/images/main/telegram-icon-yellow02.svg").default} alt="icon"/></a>
            <a href="https://www.tiktok.com/@cronikamain?_t=ZN-8vzdRUzWm8M&_r=1" target="_blank"><img src={require("@assets/images/main/tiktok-icon-yellow.svg").default} alt="icon"/></a>
            <a href="https://x.com/cronikaofficial?s=21" target="_blank"><img src={require("@assets/images/main/x-icon-yellow.svg").default} alt="icon"/></a>
            </div>
            
            
        </div>
        <div className="join-us-section">
          <h2>Join Cronika</h2>
          <p className="h3">A career as a trader with Cronika places you at the cutting edge of innovation in the digital world. Collaborate with the brightest minds in the industry to shape and create the future of trading.</p>
          {/* <Link className="basic-button"
                                                                                      to={AUTH_SIGN_UP}>Join</Link> */}
          <a className="basic-button" href={signupUrl}>Join</a>
        </div>
        <figure className="footer-img"><img src={require("@assets/images/main/footer-img.png")} alt="img"/></figure>
      </div>
    </div>
  </Layout>);
};

export default AboutUs;
